var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7769 25C19.4043 25 24.7769 19.6274 24.7769 13C24.7769 6.37258 19.4043 1 12.7769 1C6.14944 1 0.776855 6.37258 0.776855 13C0.776855 19.6274 6.14944 25 12.7769 25Z",
    fill: "#2A9CAF",
    stroke: "#14798A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36634 13.0194C7.28113 12.9354 7.23853 12.8094 7.23853 12.7254C7.23853 12.6414 7.28113 12.5154 7.36634 12.4314L7.96279 11.8434C8.1332 11.6754 8.38882 11.6754 8.55924 11.8434L8.60184 11.8854L10.945 14.3634C11.0302 14.4474 11.1581 14.4474 11.2433 14.3634L16.9521 8.52541H16.9947C17.1652 8.35741 17.4208 8.35741 17.5912 8.52541L18.1876 9.11341C18.3581 9.28141 18.3581 9.53341 18.1876 9.70141L11.3711 16.6734C11.2859 16.7574 11.2007 16.7994 11.0728 16.7994C10.945 16.7994 10.8598 16.7574 10.7746 16.6734L7.45154 13.1454L7.36634 13.0194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIcon);
export default __webpack_public_path__ + "static/media/GreenCheckIcon.52dd670e43c3f782a68d1bd10758b598.svg";
export { ForwardRef as ReactComponent };